import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
    constructor(
        private readonly httpClient: HttpClient,
    ) { }
    async downlod(id: any) {
        try {
            let paramsData = new HttpParams();
            const downlodApiUrl = environment.apiRoot + 'api/Assests/getmsi/' + id;
            return firstValueFrom(this.httpClient.get<any>(downlodApiUrl, { params: paramsData }));
        }
        catch (err) {
            console.error("Error:", err);
            return [];
        }
    }
}